import { useEffect, useRef } from 'react';
import { useWakeLock } from 'react-screen-wake-lock';
import messageBus from 'js/message-bus';

const ScreenWakeLockManager = () => {
  const { isSupported, released, request, release } = useWakeLock({
    onRequest: () => {
      messageBus.sendMessage(
        messageBus.messageTypes.screenWakeLockStateTogglePerformed,
        {
          released: false,
        }
      );
    },
    onRelease: () => {
      messageBus.sendMessage(
        messageBus.messageTypes.screenWakeLockStateTogglePerformed,
        {
          released: true,
        }
      );
    },
    onError: error =>
      // eslint-disable-next-line no-console
      console.log(
        'An error happened while trying to toggle Screen Wake Lock API: ',
        error
      ),
  });
  const releasedRef = useRef(released);
  const wasLockedBeforeTabVisibilityChangeRef = useRef(false);

  useEffect(() => {
    if (isSupported === false) {
      // eslint-disable-next-line no-console
      console.log(
        `Screen Wake Lock API is not supported in the current environment. Possible reasons:\n` +
          `- Current instance is missing HTTPS connection\n` +
          `- Current environment does not support the Screen Wake Lock API\n` +
          `- Permissions-Policy: screen-wake-lock is not set correctly`
      );
    }
  }, [isSupported]);

  useEffect(() => {
    const token = messageBus.onMessage(
      messageBus.messageTypes.screenWakeLockStateToggleRequested,
      msg => {
        if (msg.released) {
          release();
        } else {
          request();
        }
      }
    );

    return () => {
      messageBus.unsubscribe(token);
    };
  }, []);

  useEffect(() => {
    if (typeof released !== 'undefined') {
      releasedRef.current = released;
    }
  }, [released]);

  useEffect(() => {
    // Note: this event listener is needed because when user goes to another Browser tab or another app then returns back released property is reset
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        if (typeof releasedRef.current !== 'undefined') {
          wasLockedBeforeTabVisibilityChangeRef.current = !releasedRef.current;
        }
      } else if (document.visibilityState === 'visible') {
        if (wasLockedBeforeTabVisibilityChangeRef.current) {
          request();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [request]);

  return null;
};

ScreenWakeLockManager.propTypes = {};

export default ScreenWakeLockManager;
